module.exports = __webpack_public_path__ + "img/2_102.f1fb3c2f.png";